import { render, staticRenderFns } from "./fdInventory40.vue?vue&type=template&id=327fedb8"
import script from "./fdInventory40.vue?vue&type=script&lang=js"
export * from "./fdInventory40.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports